import { validarInscricaoMunicipal } from './validarInscricaoMunicipal';
import { validarCPF } from './validarCPFCNPJ';

function campoInvalido(value) {
  return value === undefined || value === null || value === '' || value === "0";
}

function formataCPF(valor) {
  return valor.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "$1.$2.$3-$4");
}

function formataCNPJ(valor) {
  return valor.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, "$1.$2.$3/$4-$5");
}

function formataCEP(valor) {
  return valor.replace(/(\d{2})(\d{3})(\d{3})/g, "$1.$2-$3");
}

function formataInscricaoMunicipal(valor) {
  return valor.replace(/(\d{1})(\d{3})(\d{3})(\d{3})(\d|x|X{1})/g, "$1.$2.$3/$4-$5");
}

function formataIndiceCadastral(valor) {
  return valor.replace(/(\d{3})(\d{3})(\d|\w| {1})(\d{3})(\d|\w| {1})(\d|\w{1})(\d{2})(\d|x|X{1})/g, "$1.$2$3.$4$5.$6$7.$8");
}

function formatar(valor) {
  valor = valor.trim();
  if (campoInvalido(valor)) return "Não informado";
  else if (valor.length === 8) return formataCEP(valor);
  else if (valor.length === 11 && validarCPF(valor)) return formataCPF(valor);
  else if (valor.length === 11 && validarInscricaoMunicipal(valor)) return formataInscricaoMunicipal(valor);
  else if (valor.length === 14) return formataCNPJ(valor);
  else if (valor.length === 15) return formataIndiceCadastral(valor);
  else return valor;
}

/**
 * Formata o campo de acordo com o tipo de formatação
 * @param {string} valor
 * @param {function} tipoFormatador
*/
function formatadorEspecifico(valor, tipoFormatador) {
  if (campoInvalido(valor)) return 'Não informado';
  else return tipoFormatador(valor);
}

export default {
  formatar,
  formatadorEspecifico,
  formataCPF,
  formataCNPJ,
  formataCEP,
  formataInscricaoMunicipal,
  formataIndiceCadastral,
}